import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Paragraph from '../../../../../../../../components/common/Paragraph';


const ModalBeneficiaries = () => {
    const [isModalVisible, setModalVisible] = useState(false);

    const hideModal = () => setModalVisible(false);
    const openModal = () => setModalVisible(true);

    const modalFooter = (
        <Button type="primary" onClick={hideModal}>
            Entendido
        </Button>
    );

    return (
        <>
            <Button
                size="small"
                type="link"
                style={{ paddingLeft: '2px', paddingRight: '2px' }}
                onClick={openModal}
            >
                <h1 className="previousStepForm__title--bold">Beneficiarios Finales de la Persona o Estructura Jurídica</h1>
            </Button>
            <InfoCircleOutlined className="modalBene__info" />
            <Modal footer={modalFooter} visible={isModalVisible} onCancel={hideModal} width={780}>
                <Paragraph strong>Beneficiarios Finales de la Persona o Estructura Jurídica</Paragraph>
                <Paragraph align="justify">
                    La(s) persona(s) natural(es) que finalmente posee, directa o indirectamente, a través de sociedades u otros mecanismos, una participación igual o mayor al 10% del capital o de los derechos a voto de una persona jurídica o estructura determinada.
                    Asimismo, se entenderá como Beneficiario Final a la(s) persona(s) natural(es) que, sin perjuicio de poseer directa o indirectamente una participación inferior al 10% del capital o de los derechos a voto de una persona jurídica o estructura jurídica, a través de sociedades u otros mecanismos, ejerce el control efectivo en la toma de decisiones de la persona jurídica o estructura jurídica.
                </Paragraph>
            </Modal>
        </>
    );
};

export default ModalBeneficiaries;
